import { CSVLink } from 'react-csv';
import styled from 'styled-components';

import { Accordion } from '../../../Accordion';
import { ChipSelect } from '../ChipSelect';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    column-gap: 0.5rem;
`;

export const StyledCSVLink = styled(CSVLink)`
    display: none;
`;

export const StyledChipSelect = styled(ChipSelect)`
    margin-top: 1rem;
    margin-bottom: 0.5rem;
`;

export const StyledAccordion = styled(Accordion)`
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
`;

export const AccordionBody = styled.div`
    padding-top: 1.125rem;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledLabel = styled.label`
    padding-left: 1rem;
    padding-right: 0.75rem;
`;
